import React from 'react'
import "./fullPageLoader.css"

function FullPageLoader() {
    return (

        <div style={{ width: '100wh', height: '100vh', position: 'relative', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', display: 'flex', position: "relative" }}>
            <div style={{ display: "flex", alignItems: "end", justifyContent: "center", flexDirection: "row" }}>
                <div className='full-page-loader-first-inactive'> <div className='full-page-loader-first' /></div>
                <div className='full-page-loader-second-inactive'> <div className='full-page-loader-second' /></div>
                <div className='full-page-loader-third-inactive'>    <div className='full-page-loader-third' /></div>
                <div className='full-page-loader-fourth-inactive'> <div className='full-page-loader-fourth' /></div>
            </div>
        </div>

    )
}

export default FullPageLoader
